import React, { useState, useEffect } from "react";
import { Table, message } from "antd";
import { useDispatch } from "react-redux";
import { getAllExams } from "../../../apicalls/exams";
import { ShowLoading, HideLoading } from "../../../redux/loaderSlice";
import SingleExam from "./SingleExam";

const LeaderboardPage = () => {
  const [exams, setExams] = useState([]);
  const [selectedExam, setSelectedExam] = useState(null);
  const dispatch = useDispatch();

  const fetchExams = async () => {
    try {
      dispatch(ShowLoading());
      const response = await getAllExams();
      dispatch(HideLoading());
      if (response.success) {
        setExams(response.data);
      } else {
        message.error(response.message);
      }
    } catch (error) {
      dispatch(HideLoading());
      message.error(error.message);
    }
  };

  useEffect(() => {
    fetchExams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      title: "Exam Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <button onClick={() => setSelectedExam(record)}>
          View Leaderboard
        </button>
      ),
    },
  ];

  return (
    <div style={{ position: "relative", minHeight: "100vh" }}>
      {selectedExam ? (
        <SingleExam exam={selectedExam} />
      ) : (
        <Table columns={columns} dataSource={exams} rowKey="_id" />
      )}
      <div
        style={{
          position: "fixed",
          bottom: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1,
          opacity: 0.7,
          fontSize: "15px",
          color: "#3c4343",
          textAlign: "center",
          fontWeight: "400",
        }}
      >
        Powered By{" "}
        <a
          href="https://www.inovexmediatech.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            fontWeight: "700",
            color: "#009900",
            textDecoration: "none",
            cursor: "pointer",
          }}
        >
          Inovex Media and Tech
        </a>
      </div>
    </div>
  );
};

export default LeaderboardPage;
